/**
 * Verteilt die Kaestchen einer Inhaltsseite fest auf Spalten.
 *
 * Mit den Spalten des Browsers (columns) verteilt sich der Inhalt bei jeder
 * Aenderung neu: faehrt ein Kaestchen aus, rechnet er die Spalten neu aus und
 * das Kaestchen landet womoeglich in einer ganz anderen. Wer es gerade
 * geoeffnet hat, verliert es aus den Augen.
 *
 * Hier bekommt jedes Kaestchen einmal seine Spalte und behaelt sie. Beim
 * Ausfahren waechst nur die eigene Spalte nach unten; die uebrigen bleiben, wo
 * sie sind. Neu verteilt wird erst, wenn sich die Breite des Fensters
 * aendert - dann sind ohnehin alle Kaestchen in Bewegung.
 */

/*
 * Ab welcher Breite wie viele Spalten.
 *
 * Als Breitenabfragen und nicht ueber window.innerWidth: die melden sich von
 * selbst, wenn sich die Breite aendert. Auf innerWidth allein war Verlass nur
 * im Moment des Ladens - drehte jemand das Geraet oder zog das Fenster auf,
 * blieb die Verteilung stehen.
 */
const DREI = window.matchMedia('(min-width: 1101px)');
const ZWEI = window.matchMedia('(min-width: 750px)');

/**
 * @returns {number}
 */
function spaltenzahl() {
  if (DREI.matches) return 3;
  if (ZWEI.matches) return 2;
  return 1;
}

/**
 * @param {HTMLElement} liste
 */
function verteile(liste) {
  const anzahl = spaltenzahl();
  if (liste.dataset.dpSpalten === String(anzahl)) return;

  /*
   * Die Kaestchen in ihrer urspruenglichen Reihenfolge einsammeln - egal, ob
   * sie gerade schon in Spalten stehen oder noch flach in der Liste.
   */
  const kaesten = [...liste.querySelectorAll('.dp-about__item')];
  if (!kaesten.length) return;

  liste.textContent = '';
  liste.dataset.dpSpalten = String(anzahl);

  const spalten = [];
  for (let i = 0; i < anzahl; i += 1) {
    const spalte = document.createElement('div');
    spalte.className = 'dp-about__spalte';
    liste.appendChild(spalte);
    spalten.push(spalte);
  }

  /*
   * Das dauerhaft offene Kaestchen bekommt seine Spalte fuer sich; die
   * uebrigen werden gleichmaessig auf die restlichen Spalten verteilt.
   *
   * Es ist so hoch wie mehrere zugeklappte - was darunter stuende, haenge
   * optisch in der Luft, waehrend die Nachbarspalten oben leer blieben. Die
   * Zaehlung bleibt dabei lesbar: innerhalb jeder Spalte laeuft sie durch.
   *
   * Verteilt wird nach Anzahl, nicht nach gemessener Hoehe: zugeklappt sind
   * alle Kaestchen gleich hoch, und die Messung vor dem Umsortieren lieferte
   * ohnehin Werte aus einer anderen Spaltenbreite.
   */
  /*
   * Ab drei Spalten steht das offene Kaestchen allein, und die uebrigen
   * teilen sich die restlichen Spalten zu gleichen Teilen.
   *
   * Bei zwei Spalten ginge das nicht auf - eine Kachel gegen elf. Dort wird
   * nach Gewicht verteilt: das offene Kaestchen zaehlt so viel wie vier
   * zugeklappte, und es wird umgebrochen, sobald eine Spalte ihren Anteil hat.
   */
  const offenesGewicht = 4;
  const gewicht = (kasten) => (kasten.querySelector('details') ? 1 : offenesGewicht);

  if (anzahl >= 3 && !kaesten[0].querySelector('details')) {
    spalten[0].appendChild(kaesten[0]);

    const rest = kaesten.slice(1);
    const proSpalte = Math.ceil(rest.length / (anzahl - 1));
    rest.forEach((kasten, i) => {
      spalten[1 + Math.min(Math.floor(i / proSpalte), anzahl - 2)].appendChild(kasten);
    });
  } else {
    const summe = kaesten.reduce((wert, kasten) => wert + gewicht(kasten), 0);
    const anteil = summe / anzahl;

    let spalte = 0;
    let inSpalte = 0;

    kaesten.forEach((kasten, i) => {
      const uebrig = kaesten.length - i;
      const freie = anzahl - spalte - 1;

      if (spalte < anzahl - 1 && inSpalte > 0 && inSpalte >= anteil && uebrig > freie) {
        spalte += 1;
        inSpalte = 0;
      }

      spalten[spalte].appendChild(kasten);
      inSpalte += gewicht(kasten);
    });
  }
}

function starte() {
  const liste = document.querySelector('.dp-about__list');
  if (!liste) return;

  verteile(liste);

  // Die Abfragen melden jeden Wechsel der Stufe.
  for (const abfrage of [DREI, ZWEI]) {
    abfrage.addEventListener('change', () => verteile(liste));
  }

  /*
   * Und einmal, wenn die Seite fertig geladen ist: beim ersten Durchgang kann
   * die Breite noch eine andere gewesen sein als die, die am Ende steht.
   */
  window.addEventListener('load', () => verteile(liste));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', starte, { once: true });
} else {
  starte();
}
